import { TableCell, Tooltip, Typography, withStyles } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import { useTranslations } from "adapters/i18n";
import React from "react";
import { TABLE_COLUMNS, PAGE_TYPE, TABLE_TYPE } from "../conciliacaoUtil";

export const ConciliationTableHeaderCell = ({
  classes,
  columnId,
  label,
  pageType,
  tableType,
}) => {
  const { t } = useTranslations();

  const firstColumn =
    tableType === TABLE_TYPE.SUMMARY
      ? TABLE_COLUMNS.ORIGIN
      : TABLE_COLUMNS.CATEGORY;
  const isLastColumn = columnId === TABLE_COLUMNS.DIFFERENCE;

  const tooltipTextMap = {
    [TABLE_COLUMNS.INITIAL_STOCK]: t("movements:initial-stock-description"),
    [TABLE_COLUMNS.INTERFUSION_BALANCE]: t(
      "movements:interfusion-balance-description"
    ),
    [TABLE_COLUMNS.FINAL_STOCK]: t("movements:final-stock-description"),
    [TABLE_COLUMNS.DIFFERENCE]: t("movements:movement-difference-description"),
  };

  const cellClassesMap = {
    [firstColumn]: classes.topLeftCell,
    [TABLE_COLUMNS.DIFFERENCE]: classes.topRightCell,
  };

  const textClassesMap = {
    [PAGE_TYPE.DEFAULT]: classes.contentTextForPage,
    [PAGE_TYPE.PRINT]: classes.contentTextForPrint,
  };

  const topRightCellStylesMap = {
    [PAGE_TYPE.DEFAULT]: { minWidth: "130px" },
    [PAGE_TYPE.PRINT]: { paddingRight: 2 },
  };

  const tooltipText = tooltipTextMap[columnId];
  const showTooltip = tooltipText != null && pageType === PAGE_TYPE.DEFAULT;

  const cellClass = cellClassesMap[columnId] || null;
  const textClass = textClassesMap[pageType];

  const cellStyles = isLastColumn ? topRightCellStylesMap[pageType] : null;

  return (
    <TableCell
      align="center"
      className={cellClass}
      padding="none"
      style={cellStyles}
    >
      <div className={classes.contentWrapper}>
        <Typography className={textClass} style={{ wordWrap: "break-word" }}>
          {label}
        </Typography>
        {showTooltip && <ColumnTooltip text={tooltipText} />}
      </div>
    </TableCell>
  );
};

const ColumnTooltip = ({ text }) => (
  <Tooltip arrow="true" title={text}>
    <InfoIcon fontSize="inherit" color="primary" style={{ fontSize: "18px" }} />
  </Tooltip>
);

const styles = (theme) => ({
  typography: {
    fontFamily: "Roboto",
  },
  topLeftCell: {
    borderRadius: "16px 0 0 0",
  },
  topRightCell: {
    borderRadius: "0 16px 0 0",
  },
  contentWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",
    padding: "0 8px",
  },
  contentTextForPage: {
    fontSize: "14px",
    fontWeight: "500",
    color: theme.palette.primary.main,
    textTransform: "uppercase",
  },
  contentTextForPrint: {
    fontSize: "12px",
    fontWeight: "500",
    color: theme.palette.primary.main,
    textAlign: "center",
    textTransform: "uppercase",
    wordBreak: "break-word",
  },
});

export default withStyles(styles)(ConciliationTableHeaderCell);
